import "./feedback.less";
import "../../html/tpl/header";
import "../../html/tpl/footer";
import { post } from "../../js/http";
import storage from "good-storage";

$(document).ready(function() {
  checkFeedback();
  $("#feedbackText").keyup(function() {
    let textLen = $("#feedbackText").val().length;
    $("#textNum span").text(textLen);
    checkFeedback();
  });

  $("#submitBtn").click(function() {
    if (!$(this).hasClass("false-btn")) {
      let data = {
        UserID: storage.get("userInfo").UserID,
        ContentText: $("#feedbackText").val(),
        ContactInforma: $("#contactText").val(),
        AppID: 103 //PC
      };
      layui.use(["layer"], function() {
        var $ = layui.jquery,
          layer = layui.layer;
        post("/ApiHome/ApiAction?_ControlName=SetUserSuggestByPC", data).then(
          res => {
            if (res.ReturnStatus) {
              layer.msg(res.MessageCN, { icon: 1 });
              setTimeout(() => {
                location.reload();
              }, 1500);
            } else {
              layer.msg(res.MessageCN, { icon: 2 });
            }
          }
        );
      });
    }
  });
});

function checkFeedback() {
  if ($("#feedbackText").val() && $("#feedbackText").val().length >= 5) {
    $("#submitBtn").removeClass("false-btn");
  } else {
    $("#submitBtn").addClass("false-btn");
  }
}
